import { subject } from '@casl/ability';

export const createPermissions = () => ({
  install(app) {
    // Permissions contested to specific node
    app.config.globalProperties.$canDo = function (verbName, subjectName) {
      if (window.localStorage.contextnodeid) {
        const contextnodeid = window.localStorage.contextnodeid || undefined;
        const castedSubject = subject(subjectName, {rootnodeid: contextnodeid});

        return this.$can(verbName, castedSubject);
      }

      return this.$can(verbName, subjectName);
    };

    // Permissions contested to specific node
    app.config.globalProperties.$allowedTo = function (verbName, subjectName, accessPointId) {
      const castedSubject = subject(subjectName, { rootnodeid: accessPointId });
      return this.$can(verbName, castedSubject);
    };

    app.config.globalProperties.$updateAbilities = function(abilities) {
      // The abilities are also updated in the App.vue file at startup
      this.$ability.update(abilities);
      window.localStorage.abilities = JSON.stringify(abilities);
    };

    app.config.globalProperties.$canListUser = function() {
      return this.$canDo('list', 'User');
    };

    app.config.globalProperties.$canControlUser = function() {
      return this.$canDo('control', 'User');
    };

    app.config.globalProperties.$canBelongstoTeam = function() {
      return this.$canDo('belongsto', 'Team');
    };

    app.config.globalProperties.$canControlTenantConfig = function() {
      return this.$canDo('control', 'TenantConfiguration');
    };

    app.config.globalProperties.$canPurchaseResources = function() {
      return this.$canDo('purchaseResources', 'TenantConfiguration');
    };

    app.config.globalProperties.$canListNodeAndPod = function() {
      return this.$canDo('list', 'NodeAndPod');
    };

    app.config.globalProperties.$canControlNodeAndPod = function() {
      return this.$canDo('control', 'NodeAndPod');
    };

    app.config.globalProperties.$canDownloadNodeAndPod = function() {
      return this.$canDo('download', 'NodeAndPod');
    };

    app.config.globalProperties.$canViewPodAndNodeAnalytics = function() {
      return this.$canDo('viewAnalytics', 'NodeAndPod');
    };

    app.config.globalProperties.$canLabelPods = function() {
      return this.$canDo('label', 'Pod');
    };

    app.config.globalProperties.$canListAsset = function() {
      return this.$canDo('list', 'Asset');
    };

    app.config.globalProperties.$canUploadFileAndAsset = function() {
      return this.$canDo('upload', 'FileAndAsset');
    };

    app.config.globalProperties.$canArchiveNodeAndPod = function() {
      return this.$canDo('archive', 'NodeAndPod');
    };

    app.config.globalProperties.$canListShareLinks = function() {
      return this.$canDo('list', 'ShareLinks');
    };

    app.config.globalProperties.$canControlShareLinks = function() {
      return this.$canDo('control', 'ShareLinks');
    };

    app.config.globalProperties.$canListPodService = function() {
      return this.$canDo('list', 'PodService');
    }

    app.config.globalProperties.$canControlPodService = function() {
      return this.$canDo('control', 'PodService');
    }

    app.config.globalProperties.$canRunFreeService = function() {
      return this.$canDo('run', 'FreeService');
    }

    app.config.globalProperties.$canRunPaidService = function() {
      return this.$canDo('run', 'PaidService');
    }

    app.config.globalProperties.$canDeleteNodeAndPod = function() {
      return this.$canDo('delete', 'NodeAndPod');
    };

    app.config.globalProperties.$isTeamUser = function() {
      return this.$canBelongstoTeam();
    }

    app.config.globalProperties.$isClientUser = function() {
      return !this.$canBelongstoTeam();
    }

    app.config.globalProperties.$isFCPExtension = function() {
      if (window.webkit && window.webkit.messageHandlers) {
        return true;
      }
      return false;
    }

    app.config.globalProperties.$isAdobeExtension = function() {
      return !!window.cep;
    }

    app.config.globalProperties.$belongsToTeam = function(accessPointId) {
      return this.$allowedTo('belongsto', 'Team', accessPointId);
    };
  }
});
